"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var react_jss_1 = __importStar(require("react-jss"));

var defaultTheme = {
  background: '#975422',
  font: "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif",
  titleFont: null,
  accentColor: '#f76b1c',
  paperBackground: '#f2f2f2',
  homeButtonColor: null
};

var styles = function styles(theme) {
  return {
    '@global': {
      body: {
        backgroundImage: theme.background === defaultTheme.background ? 'linear-gradient(#553319, #ca6e28)' : '',
        backgroundColor: theme.background,
        backgroundAttachment: 'fixed',
        fontFamily: theme.font,
        height: '100%',
        width: '100%',
        margin: 0,
        fontSmoothing: 'antialiased'
      },
      html: {
        height: '100%',
        width: '100%'
      },
      '#root': {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
      }
    },
    container: {
      maxWidth: 740,
      width: '100%',
      padding: '0 8px',
      boxSizing: 'border-box'
    }
  };
};

var Container = function Container(_a) {
  var children = _a.children,
      classes = _a.classes;
  return react_1.default.createElement("div", {
    className: classes.container
  }, children);
};

var WrappedContainer = react_jss_1.default(styles)(Container);

var Template = function Template(_a) {
  var children = _a.children,
      theme = _a.theme;
  return react_1.default.createElement(react_jss_1.ThemeProvider, {
    theme: __assign({}, defaultTheme, theme)
  }, react_1.default.createElement(WrappedContainer, null, children));
};

exports.default = Template;